// Shared Authorize.Net workspace section nav — Dashboard / Subscriptions / Tx Reconciliation, all on
// the new "-new" routes. Used by ReconWorkspace (recon screen) and the new Dashboard/Subscriptions
// pages so the nav is defined once. `buildAuthnetNav` returns the { active, items, onNav } the shared
// WorkspaceHeader expects, carrying the selected account (?acct) across screens.
import React from 'react';
import DashboardIcon from '@mui/icons-material/SpaceDashboard';
import SubscriptionsIcon from '@mui/icons-material/Autorenew';
import ReconcileIcon from '@mui/icons-material/FactCheck';

export const AUTHNET_NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: <DashboardIcon fontSize="small" />, path: '/payments/authnet' },
  { key: 'subscriptions', label: 'Subscriptions', icon: <SubscriptionsIcon fontSize="small" />, path: '/payments/authnet/subscriptions' },
  { key: 'reconciliation', label: 'Tx Reconciliation', icon: <ReconcileIcon fontSize="small" />, path: '/payments/authnet/reconciliation' },
];

export const buildAuthnetNav = (active, account, navigate) => ({
  active,
  items: AUTHNET_NAV_ITEMS,
  onNav: (key) => {
    const it = AUTHNET_NAV_ITEMS.find((x) => x.key === key);
    if (it) navigate(`${it.path}${account && account !== 'all' ? `?acct=${account}` : ''}`);
  },
});
